/**
 * Modelli di riferimento F1F2 — tipologia lavorazione e tipologia intervento.
 */

export const TIPOLOGIE_LAVORAZIONE: readonly string[] = [
  'Adeguamento Sito SSI',
  'BANDO 5G',
  'Bonifica Infra/Sicurezza',
  'Colocazione 4G/5G',
  'Modifica Impianto Altro Operator',
  'Modifica Impianto SSI',
  'Nuova Microcella',
  'Nuovo HUB',
  'Nuovo MW',
  'Nuovo Sito',
  'Nuovo Sito SSI 5.0',
  'Predisposizione TELECOM 5.0',
  'Rimozione MW',
  'Rimozione Sito',
  'RIMOZIONE SITO-LLD',
  'Settorializzazione',
  'Swap Apparati',
  'Trasferimento Sito',
  'Trasferimento Sito SSI 5.0',
  'Upgrade MW HW',
] as const;

export const TIPOLOGIE_INTERVENTO: readonly string[] = [
  'Sopralluogo',
  'Installazione',
  'Manutenzione Ordinaria',
  'Manutenzione Straordinaria',
  'Dismissione',
  'Collaudo',
  'Ripristino',
] as const;
